"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGES_INIT_STATE = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
exports.PAGES_INIT_STATE = {
    currentPage: 0,
    list: [],
    pageOrderWithRotation: []
};
const extractQuestions = (group, groups) => {
    return group.children.reduce((acc, { type, id }) => {
        switch (type) {
            case 'question': {
                acc.push(id);
                break;
            }
            case 'group': {
                // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
                acc = acc.concat(extractQuestions(groups[id]));
                break;
            }
            default:
        }
        return acc;
    }, []);
};
// eslint-disable-next-line max-statements, complexity
const pages = (state = (0, cloneDeep_1.default)(exports.PAGES_INIT_STATE), action) => {
    switch (action.type) {
        case 'SURVEY_SET_INITED':
        case 'SURVEY_LOADED_FROM_CONFIG': {
            const { pageOrder, groups, pageOrderWithRotation = [] } = action.data;
            const pages = pageOrder.map(pageIndex => {
                return Object.assign(Object.assign({}, groups[pageIndex]), { questionIds: extractQuestions(groups[pageIndex], groups), visible: true });
            });
            return (0, cloneDeep_1.default)({
                currentPage: 0,
                list: pages,
                pageOrderWithRotation
            });
        }
        case 'SET_CURRENT_PAGE': {
            const { pageNumber } = action.data;
            const newState = (0, cloneDeep_1.default)(state);
            newState.currentPage = pageNumber;
            return newState;
        }
        case 'MOVE_NEXT_PAGE': {
            const newState = (0, cloneDeep_1.default)(state);
            newState.currentPage = action.to;
            return newState;
        }
        case 'NODE_VISIBILITY_CHANGED': {
            const newState = (0, cloneDeep_1.default)(state);
            let pagesList = newState.list;
            action.nodes.forEach(node => {
                if (node.type !== 'group') {
                    return;
                }
                // оптимизировать (сделать list объектом по ключам)
                pagesList = pagesList.map(item => {
                    if (item.id === Number(node.id)) {
                        item.visible = node.state;
                    }
                    return item;
                });
            });
            newState.list = pagesList;
            return newState;
        }
        default:
            return state;
    }
};
exports.default = pages;
